import React from 'react';
import Navigation from '../../Components/Navigation/Navigation';
import Office from '../../Components/OfficeComp/Office';
import Footer from '../../Components/Footer/Footer';

const OfficePage = () => {
  return (
    <>
      <Navigation />
      <Office />
      <Footer />
    </>
  );
};

export default OfficePage;
